<mat-card>
  <mat-card-header>
    <mat-card-title>Add Charity Payout</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="payoutForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <app-filterable-dropdown
          [optionsSetter]="charityOptions"
          [selectedId]="selectedCharityId"
          placeholder="Select a charity..."
          (selectionChange)="onCharitySelected($event)"
          (selectionCleared)="onCharityCleared()">
        </app-filterable-dropdown>
        @if (payoutForm.get('charityId')?.invalid && payoutForm.get('charityId')?.touched) {
          <mat-error class="error-text">Charity is required</mat-error>
        }
      </div>

      @if (charityBalance) {
        <div class="balance-info">
          <div class="balance-item">
            <span class="balance-label">Total Contributions:</span>
            <span class="balance-value">{{ charityBalance.TotalContributions | formatCurrency }}</span>
          </div>
          <div class="balance-item">
            <span class="balance-label">Total Payouts:</span>
            <span class="balance-value">{{ charityBalance.TotalPayouts | formatCurrency }}</span>
          </div>
          <!-- Adjustments feed Amount Owed, so without them on screen the admin deciding what to pay sees
               contributions minus payouts that does not reconcile to the figure they are acting on. -->
          <div class="balance-item">
            <span class="balance-label">Adjustments:</span>
            <span class="balance-value" data-testid="add-payout-adjustments">{{ charityBalance.TotalAdjustments | formatCurrency }}</span>
          </div>
          <div class="balance-item amount-owed-item">
            <span class="balance-label">Amount Owed:</span>
            <span class="balance-value amount-owed" data-testid="add-payout-amount-owed">{{ charityBalance.AmountOwed | formatCurrency }}</span>
          </div>
        </div>
      }

      <div class="form-group">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Payout Amount ($)</mat-label>
          <input
            matInput
            type="text"
            formControlName="payoutAmount"
            placeholder="Enter amount in dollars"
            (input)="sanitizeCurrencyInput($event)"
            data-testid="payout-amount-input">
          @if (charityBalance && charityBalance.AmountOwed) {
            <button
              mat-button
              matSuffix
              type="button"
              (click)="fillFullAmountOwed()"
              matTooltip="Fill with full amount owed"
              data-testid="fill-full-amount-button">
              Fill
            </button>
          }
          @if (payoutForm.get('payoutAmount')?.hasError('required') && payoutForm.get('payoutAmount')?.touched) {
            <mat-error>Payout amount is required</mat-error>
          }
          @if (payoutForm.get('payoutAmount')?.hasError('min') && payoutForm.get('payoutAmount')?.touched) {
            <mat-error>Payout amount must be greater than $0.00</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="form-group">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Payment Date</mat-label>
          <input
            matInput
            type="date"
            formControlName="paymentDate"
            data-testid="payout-payment-date-input">
        </mat-form-field>
      </div>

      <div class="form-group">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Reference # (Optional)</mat-label>
          <input
            matInput
            type="text"
            formControlName="referenceNumber"
            placeholder="Cheque #, EFT / e-transfer reference…"
            maxlength="100"
            data-testid="payout-reference-input">
        </mat-form-field>
      </div>

      @if (payoutWarning) {
        <div class="warning-message" [ngClass]="payoutWarning.type">
          <mat-icon>{{ payoutWarning.type === 'overpayment' ? 'warning' : 'info' }}</mat-icon>
          <span>{{ payoutWarning.message }}</span>
        </div>
      }

      <div class="form-group">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Note @if (payoutWarning?.type === 'overpayment') {<span class="required-indicator">*</span>} @else {(Optional)}</mat-label>
          <textarea
            matInput
            formControlName="note"
            placeholder="Add a note about this payout"
            rows="3"
            data-testid="payout-note-input"></textarea>
          @if (payoutForm.get('note')?.hasError('required') && payoutForm.get('note')?.touched) {
            <mat-error>A note is required when the payout amount exceeds the amount owed</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="form-actions">
        <button
          mat-raised-button
          color="primary"
          type="submit"
          [disabled]="payoutForm.invalid || isSubmitting"
          data-testid="submit-payout-button">
          {{ isSubmitting ? 'Creating...' : 'Create Payout' }}
        </button>
      </div>
    </form>
  </mat-card-content>
</mat-card>
